import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { useAppSelector } from '../hook';

export type ScoreState = {
  totalScore: number;
};

const initialState: ScoreState = {
  totalScore: 0,
};

export const scoreSlice = createSlice({
  name: 'score',
  initialState,
  reducers: {
    setTotalScore: (state, action: PayloadAction<number>) => {
      state.totalScore = action.payload;
    },
  },
});

export const { setTotalScore } = scoreSlice.actions;

export const getScoreState = (state: RootState) => state.score;

export const useScoreState = () => useAppSelector(getScoreState);

export default scoreSlice.reducer;
